import React from "react";

import { SVGDeclineIcon } from "../../svg-animated/svg-animated";
import { Box, PageActionsContainer } from "../../theme/containers";
import { Paragraph, PcaHeading, PcaSubHeading } from "../../theme/typography";
import { PrimaryButton } from "../../simple-buttons/simple-buttons";

const JourneyError = () => {
    return (
        <div className="u-text-centre">
            <Box className="u-mx-auto">
                <SVGDeclineIcon />
            </Box>
            <PcaHeading className="u-my-6">Something went wrong</PcaHeading>
            <PcaSubHeading>Sorry, we cannot complete your application right now.</PcaSubHeading>
            <Paragraph>Please refresh the page and try again.</Paragraph>
            <PageActionsContainer className="block" id="actions">
                <PrimaryButton onClick={() => window.location.reload()} text="Refresh" />
            </PageActionsContainer>
        </div>
    );
}

export default JourneyError;
